import { render, staticRenderFns } from "./RenewalApplication.vue?vue&type=template&id=81c6bdd6&"
import script from "./RenewalApplication.vue?vue&type=script&lang=js&"
export * from "./RenewalApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports